// Zapytania o wspólny wybór nagłówka z tokenem logowania, ale bez wylogowania przy 401/403
// (authenticatedFetch czyści wtedy token i przenosi do logowania — odmowa zapisu ustawień nie może tego robić).
import { pobierzZTokenem } from '@ui'

export const pobierzPreferencji = pobierzZTokenem(() => {
  try { return sessionStorage.getItem('authToken') } catch { return null }
})
